import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import ProductCardLegal from './../block/ProductCardLegal'
import AkciiSlyder from './../block/AkciiSlyder'
import TestimonialsSection from './../block/TestimonialsSection'
import FAQSection from './../block/FAQSection'

export default class Product extends Component {

  render() {

    const { data, ajax_data, changeFavorite, favorite, cart, addTocart, user_profile_type } = this.props

    return (
      <>
        <Breadcrumbs items={ajax_data.breadcrumbs} />
        <ProductCardLegal
          options={data?.page_data || {}}
          ajax_data={ajax_data}
          changeFavorite={changeFavorite}
          favorite={favorite}
          link_optproducts={data?.page_data?.link_optproducts || ``}
        />
        <AkciiSlyder
          page_data={data?.page_data || {}}
          slydes={ajax_data?.akciislyder || []}
          hidetitle={false}
        />
        <TestimonialsSection
          page_data={data?.page_data || {}}
          feedback={ajax_data?.feedback_ng || []}
          feedback_legal={ajax_data?.feedback_ng_legal || []}
          user_profile_type={user_profile_type}
        />
        <FAQSection
          qwestions={user_profile_type == `legal` ? ( ajax_data?.qwestions_ng_legal || [] ) : ( ajax_data?.qwestions_ng || [] )}
        />
      </>
    )
  }
}

Product.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object,
  changeFavorite: PropTypes.func,
  favorite: PropTypes.array,
  cart: PropTypes.array,
  addTocart: PropTypes.func,
  user_profile_type: PropTypes.string
}